import type { StockerLoadPortKind } from './StockerLoadPortBank';

export type StockerLifterTransferState = {
  isTransferring: boolean;
  activePortKind: StockerLoadPortKind | null;
  transferProgress01: number;
  transferOperation: 'PICKUP' | 'DROP' | 'TRANSFER';
  foupPresent: boolean;
  occupiedPorts: Partial<Record<StockerLoadPortKind, boolean>>;
};

export const STOCKER_LIFTER_IDLE: StockerLifterTransferState = {
  isTransferring: false,
  activePortKind: null,
  transferProgress01: 0,
  transferOperation: 'PICKUP',
  foupPresent: false,
  occupiedPorts: {},
};

type Listener = () => void;
const stateById = new Map<string, StockerLifterTransferState>();
const listeners = new Set<Listener>();

export const stockerTransferLifterStore = {
  get(id?: string | null): StockerLifterTransferState {
    if (!id) return STOCKER_LIFTER_IDLE;
    return stateById.get(id) ?? STOCKER_LIFTER_IDLE;
  },

  set(id: string, state: StockerLifterTransferState) {
    stateById.set(id, state);
    listeners.forEach((l) => l());
  },

  clear(id: string) {
    if (stateById.delete(id)) {
      listeners.forEach((l) => l());
    }
  },

  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
};
